
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Eye, Trash2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface AppointmentActionsProps {
  appointment: any;
  onStatusUpdate: (appointmentId: string, status: string) => void;
  onViewReceipt: (appointmentId: string) => void;
  onViewDetails: (appointment: any) => void;
  onDelete: (appointmentId: string) => void;
  isUpdating: boolean;
  isDeleting: boolean;
}

export const AppointmentActions = ({
  appointment,
  onStatusUpdate,
  onViewReceipt,
  onViewDetails,
  onDelete,
  isUpdating,
  isDeleting,
}: AppointmentActionsProps) => {
  console.log('AppointmentActions - rendering for appointment:', appointment?.id);
  console.log('AppointmentActions - appointment status:', appointment?.status);
  console.log('AppointmentActions - isUpdating:', isUpdating);
  console.log('AppointmentActions - isDeleting:', isDeleting);
  
  if (!appointment) {
    console.log('AppointmentActions - No appointment data');
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 justify-end">
      {/* Bouton Détails - TOUJOURS visible */}
      <Button
        variant="blue"
        size="sm"
        onClick={() => {
          console.log('Détails button clicked for appointment:', appointment.id);
          onViewDetails(appointment);
        }}
        className="flex items-center gap-2 shadow-md hover:shadow-lg transition-all duration-200"
      >
        <Eye className="h-4 w-4" />
        Détails
      </Button>
      
      {/* Boutons pour les demandes en attente */}
      {appointment.status === 'pending' && (
        <>
          <Button
            variant="green"
            size="sm"
            onClick={() => {
              console.log('Accepter button clicked for appointment:', appointment.id);
              onStatusUpdate(appointment.id, 'confirmed');
            }}
            disabled={isUpdating}
            className="flex items-center gap-2 shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <CheckCircle className="h-4 w-4" />
            {isUpdating ? 'En cours...' : 'Accepter'}
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={() => {
              console.log('Refuser button clicked for appointment:', appointment.id);
              onStatusUpdate(appointment.id, 'cancelled');
            }}
            disabled={isUpdating}
            className="flex items-center gap-2 shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <XCircle className="h-4 w-4" />
            {isUpdating ? 'En cours...' : 'Refuser'}
          </Button>
        </>
      )}
      
      {/* Bouton Reçu pour les rendez-vous confirmés */}
      {appointment.status === 'confirmed' && (
        <Button
          variant="secondary"
          size="sm"
          onClick={() => {
            console.log('Reçu button clicked for appointment:', appointment.id);
            onViewReceipt(appointment.id);
          }}
          className="flex items-center gap-2 shadow-md hover:shadow-lg transition-all duration-200"
        >
          <Eye className="h-4 w-4" />
          Reçu
        </Button>
      )}
      
      {/* Bouton Supprimer avec confirmation */}
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            disabled={isDeleting}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-700 hover:bg-gray-50 border-gray-300 shadow-md hover:shadow-lg transition-all duration-200"
          >
            <Trash2 className="h-4 w-4" />
            {isDeleting ? 'Suppression...' : 'Supprimer'}
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Supprimer le rendez-vous</AlertDialogTitle>
            <AlertDialogDescription>
              Êtes-vous sûr de vouloir supprimer ce rendez-vous ? Cette action est irréversible.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Annuler</AlertDialogCancel>
            <AlertDialogAction 
              onClick={() => {
                console.log('Delete confirmed for appointment:', appointment.id);
                onDelete(appointment.id);
              }}
              disabled={isDeleting}
              className="bg-red-600 hover:bg-red-700"
            >
              {isDeleting ? "Suppression..." : "Supprimer"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
